import axiosInstance from '../utils/axiosInstance';

export type TranscriptCleanupMode = 'clean' | 'summarise';

interface CleanupTranscriptResponse {
  success: boolean;
  data: { text: string };
}

export const cleanupTranscript = async (
  text: string,
  mode: TranscriptCleanupMode,
): Promise<string> => {
  const response = await axiosInstance.post<CleanupTranscriptResponse>(
    '/transcript-cleanup',
    { text, mode },
  );
  return response.data.data.text;
};
